import routeName from '../constant';

const routes = [{
    path: 'transform-terms',
    name: routeName.TRANSFORM_TERMS,
    component: () => import('@/views/aplCatl640and631/A6/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '投資標的轉換說明', leaveAlert: true, code: 'A6', unableBack: true },
},
{
    path: 'transform-export',
    name: routeName.TRANSFORM_EXPORT,
    component: () => import('@/views/aplCatl640and631/A6/export/Index.vue'),
    meta: { auth: true, metaTitle: '轉出投資標的', leaveAlert: true, code: 'A6', unableBack: true },
},
{
    path: 'transform-import',
    name: routeName.TRANSFORM_IMPORT,
    component: () => import('@/views/aplCatl640and631/A6/import/Index.vue'),
    meta: { auth: true, metaTitle: '轉入投資標的', leaveAlert: true, code: 'A6', unableBack: true },
},
];

export default routes;
